<template>
  <div id="log-candidato-pratico">
    <vuestic-widget headerText="Consultas Realizadas na api do Getran">
      <div v-if="!loaded">
        <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
          <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
            <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
            </component>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="row">
          <div class="col-md-3">
            <button class="btn btn-micro btn-info seachButtons" @click="openModal">
              <i class="fa fa-download"></i>
              Relátorio
            </button>
          </div>
        </div>

        <form class="mt-5 mb-5 form" @submit.prevent="handleConsult">
          <div class="row mb-3">
            <fieldset class="col-md-3 inputs">
              <legend>Auto Escola</legend>
              <model-select :options="selectCFC" v-model="autoescola" placeholder="Selecione uma auto escola"
                ref="autoescola">
                <option>Selecione uma função</option>
              </model-select>
            </fieldset>

            <fieldset class="col-md-3 inputs" id="nome">
              <legend>Usuário</legend>
              <input type="text" class="form-control pl-2 border rounded" id="nome_usuario" v-model="inputs.usuario"
                placeholder="Usuário" />
            </fieldset>

            <fieldset class="col-md-3" id="inicioProcesso">
              <legend>Data aula inicial*</legend>
              <input type="date" class="form-control border rounded pl-2 pr-2" v-model="inputs.initialPeriod" />
            </fieldset>

            <fieldset class="col-md-3" id="inicioProcesso">
              <legend>Data aula final*</legend>
              <input type="date" class="form-control border rounded pl-2 pr-2" v-model="inputs.finalPeriod" />
            </fieldset>
          </div>

          <div class="row">

            <div class="col-md-3 d-flex align-items-end">
              <button type="submit" class="btn btn-block btn-micro btn-info seachButtons" :disabled="table.load">
                <template v-if="table.load">
                  <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                    <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                      <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="17">
                      </component>
                    </div>
                  </div>
                </template>

                <template v-else>
                  <i class="fa fa-search"></i>
                  Consultar
                </template>
              </button>
            </div>

            <div class="col-md-3 d-flex align-items-end">
              <button type="button" class="btn btn-block btn-micro btn-danger seachButtons" :disabled="table.load"
                @click="clearInputs">
                <template v-if="table.load">
                  <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                    <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                      <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="17">
                      </component>
                    </div>
                  </div>
                </template>

                <template v-else>
                  <i class="fa fa-trash"></i>
                  Limpar
                </template>
              </button>
            </div>
          </div>
        </form>

        <!-- Resumo Geral -->
        <div v-if="processedAutoescolas && processedAutoescolas.length" class="mt-5">
          <!-- Header da Seção -->
          <div class="section-header mb-4">
            <p class="section-subtitle text-muted">
              Visualização detalhada das consultas realizadas, agrupadas por autoescola e usuário
            </p>
          </div>

          <!-- Cards de Métricas Gerais -->
          <div class="row mb-4">
            <div class="col-md-4">
              <div class="metric-card">
                <div class="metric-icon bg-primary">
                  <i class="fa fa-building"></i>
                </div>
                <div class="metric-content">
                  <h4 class="metric-number">{{ processedAutoescolas.length }}</h4>
                  <p class="metric-label">Autoescolas</p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="metric-card">
                <div class="metric-icon bg-success">
                  <i class="fa fa-users"></i>
                </div>
                <div class="metric-content">
                  <h4 class="metric-number">{{ totalUsuarios }}</h4>
                  <p class="metric-label">Usuários Ativos</p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="metric-card">
                <div class="metric-icon bg-warning">
                  <i class="fa fa-search"></i>
                </div>
                <div class="metric-content">
                  <h4 class="metric-number">{{ totalConsultas }}</h4>
                  <p class="metric-label">Total de Consultas</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Cards das Autoescolas -->
          <div class="autoescolas-grid">
            <div v-for="(auto, idx) in processedAutoescolas" :key="auto.schema || idx" class="autoescola-card">
              <!-- Header do Card -->
              <div class="card-header-modern">
                <div class="autoescola-info">
                  <div class="autoescola-avatar">
                    {{ auto.formattedName.charAt(0).toUpperCase() }}
                  </div>
                  <div class="autoescola-details">
                    <h5 class="autoescola-name">{{ auto.formattedName }}</h5>
                    <p class="autoescola-schema">{{ auto.schema }}</p>
                  </div>
                </div>
                <div class="total-badge">
                  <span class="total-number">{{ auto.total_autoescola || 0 }}</span>
                  <span class="total-label">consultas</span>
                </div>
              </div>

              <!-- Conteúdo do Card -->
              <div class="card-content">
                <!-- Top 3 Usuários -->
                <div class="top-users mb-3">
                  <h6 class="content-title">
                    <!-- <i class="fa fa-trophy text-warning mr-1"></i>
                    Top Usuários -->
                  </h6>
                  <div class="users-ranking">
                    <div 
                      v-for="(usuario, index) in auto.topUsers" 
                      :key="usuario.id_usuario || `${idx}-${index}`"
                      class="user-rank-item"
                      :class="getRankClassStatic(index)"
                    >
                      <div class="rank-position">{{ index + 1 }}</div>
                      <div class="user-info">
                        <span class="user-name">{{ usuario.nome_usuario || 'Usuário' }}</span>
                        <span class="user-count">{{ usuario.total || 0 }} consultas</span>
                      </div>
                      <div class="progress-bar">
                        <div 
                          class="progress-fill" 
                          :style="{ width: getProgressWidthStatic(usuario.total, auto.total_autoescola) + '%' }"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Botão para Ver Todos -->
                <div v-if="auto.usuarios.length > 3" class="text-center">
                  <button 
                    class="btn btn-outline-primary btn-sm toggle-btn"
                    @click="toggleExpandCard(idx)"
                  >
                    <i :class="auto.isExpanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                    {{ auto.isExpanded ? 'Ver Menos' : `Ver Todos (${auto.usuarios.length})` }}
                  </button>
                </div>

                <!-- Tabela Completa (Expandida) -->
                <div v-if="auto.isExpanded" class="full-table mt-3">
                  <div class="table-header">
                    <h6 class="content-title">
                      <i class="fa fa-list text-info mr-1"></i>
                      Todos os Usuários
                    </h6>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-hover table-modern">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Usuário</th>
                          <th>Consultas</th>
                          <th>Percentual</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(usuario, index) in auto.usuarios" :key="usuario.id_usuario || `${idx}-table-${index}`">
                          <td>
                            <span class="table-rank">{{ index + 1 }}</span>
                          </td>
                          <td>
                            <div class="table-user">
                              <div class="user-avatar-small">
                                {{ (usuario.nome_usuario || 'U').charAt(0).toUpperCase() }}
                              </div>
                              <span class="user-name-table">{{ usuario.nome_usuario || 'Usuário' }}</span>
                            </div>
                          </td>
                          <td>
                            <span class="count-badge">{{ usuario.total || 0 }}</span>
                          </td>
                          <td>
                            <div class="percentage-container">
                              <span class="percentage-text">
                                {{ auto.total_autoescola > 0 ? ((usuario.total / auto.total_autoescola) * 100).toFixed(1) : '0.0' }}%
                              </span>
                              <div class="mini-progress">
                                <div 
                                  class="mini-progress-fill" 
                                  :style="{ width: getProgressWidthStatic(usuario.total, auto.total_autoescola) + '%' }"
                                ></div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ...existing code... -->
      </div>
    </vuestic-widget>

    <vuestic-modal :show.sync="modal.show" ref="fileModal" v-bind:small="false" cancelClass="none" okClass="none">
      <vuestic-tabs :names="['PDF', 'XLSX']" ref="tabs">
        <div slot="PDF">
          <div class="row justify-content-center">
            <div v-if="downloadPDFLoading" class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
              <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="55"></component>
              </div>
            </div>
            <button v-else class="btn btn-primary" @click="downloadFilePDF" :disabled="downloadPDFLoading">Download
              PDF</button>
          </div>
        </div>

        <div slot="XLSX">
          <div class="row justify-content-center">
            <!-- Barra de Progresso -->
            <div v-if="isDownloading" class="col-12 mb-3">
              <div class="progress-container">
                <div class="progress-info mb-2">
                  <span class="progress-label">Baixando relatório...</span>
                  <span class="progress-percentage">{{ Math.round(downloadProgress) }}%</span>
                </div>
                <div class="progress-bar-custom">
                  <div 
                    class="progress-fill-custom" 
                    :style="{ width: downloadProgress + '%' }"
                  ></div>
                </div>
              </div>
            </div>

            <!-- Botão de Download -->
            <div v-if="!isDownloading" class="col-sm-12 d-flex justify-content-center">
              <button 
                class="btn btn-primary" 
                @click="downloadFileXLSX" 
                :disabled="downloadXLSXLoading"
              >
                <i class="fa fa-file-excel-o mr-2"></i>
                Download XLSX
              </button>
            </div>

            <!-- Botão de Cancelar (durante download) -->
            <div v-if="isDownloading" class="col-sm-12 d-flex justify-content-center">
              <button 
                class="btn btn-outline-secondary btn-sm" 
                @click="cancelDownload"
              >
                <i class="fa fa-times mr-1"></i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </vuestic-tabs>
    </vuestic-modal>
  </div>
</template>

<script>
import urlApi from '@/router/urlApiV2.js'
import * as spinners from 'epic-spinners'
import utils from '../../../../services/utils'
import { ModelSelect } from 'vue-search-select'
import pagination from '../../../pagination/pagination'

export default {
  name: 'LogAgendamento',
  components: {
    ...spinners,
    ModelSelect,
    pagination,
  },
  data() {
    return {
      utils: utils,
      autoescola: '',
      modal: {
        show: false,
        load: false,
      },
      inputs: {
        usuario: '',
        initialPeriod: '',
        finalPeriod: ''
      },
      table: {
        currentPage: '',
        data: '',
        firstPageUrl: '',
        from: '',
        lastPage: '',
        lastPageUrl: '',
        nextPageUrl: '',
        path: '',
        perPage: '',
        prevPageUrl: '',
        to: '',
        total: '',
        pages: [],
        load: false
      },
      selectCFC: [],
      loaded: false,
      pagination: '',
      autoescolasComUsuarios: [],
      expandedCards: [],
      downloadPDFLoading: false,
      downloadXLSXLoading: false,
      // Progresso do download XLSX
      downloadProgress: 0,
      isDownloading: false,
      downloadController: null,
      progressInterval: null, // Para controlar a simulação de progresso
      // Cache para evitar recálculos
      lastProcessedData: null,
      lastExpandedState: []
    }
  },
  computed: {
    // Métricas gerais com cache
    totalUsuarios() {
      if (!this.autoescolasComUsuarios || !Array.isArray(this.autoescolasComUsuarios)) {
        return 0
      }
      return this.autoescolasComUsuarios.reduce((total, auto) => {
        return total + (auto.usuarios && Array.isArray(auto.usuarios) ? auto.usuarios.length : 0)
      }, 0)
    },
    totalConsultas() {
      if (!this.autoescolasComUsuarios || !Array.isArray(this.autoescolasComUsuarios)) {
        return 0
      }
      return this.autoescolasComUsuarios.reduce((total, auto) => {
        return total + (typeof auto.total_autoescola === 'number' ? auto.total_autoescola : 0)
      }, 0)
    },
    
    // Cache dos dados processados para evitar recálculos
    processedAutoescolas() {
      if (!this.autoescolasComUsuarios || !Array.isArray(this.autoescolasComUsuarios)) {
        return []
      }
      
      // Cache inteligente - só reprocessa se os dados mudaram
      const currentDataHash = JSON.stringify(this.autoescolasComUsuarios) + JSON.stringify(this.expandedCards)
      if (this.lastProcessedData && this.lastProcessedData.hash === currentDataHash) {
        return this.lastProcessedData.result
      }
      
      const result = this.autoescolasComUsuarios.map((auto, idx) => {
        // Garantir que usuarios seja sempre um array
        const usuarios = auto.usuarios && Array.isArray(auto.usuarios) ? auto.usuarios : []
        
        // Cache dos top usuários ordenados
        const topUsers = usuarios
          .slice() // Criar uma cópia para não mutar o original
          .sort((a, b) => (b.total || 0) - (a.total || 0))
          .slice(0, 3)
        
        // Cache do nome formatado
        const formattedName = this.formatAutoescolaNameStatic(auto.schema)
        
        return {
          ...auto,
          usuarios: usuarios,
          topUsers: topUsers,
          formattedName: formattedName,
          isExpanded: this.expandedCards.includes(idx)
        }
      })
      
      // Salvar no cache
      this.lastProcessedData = {
        hash: currentDataHash,
        result: result
      }
      
      return result
    }
  },
  async created() {
    await this.loadCfcs()

    this.loaded = true
  },
  methods: {
    async loadCfcs() {
      let selectCFC = []

      await this.$http.get(`${urlApi}/autoescola`)
        .then(response => {
          response.data.dados.map(autoescolas => {
            if (autoescolas.nome_fantasia !== '!TESTE') {
              selectCFC.push({
                value: autoescolas.tenant_schema,
                text: autoescolas.nome_fantasia,
              })
            }
          })
        })

      this.selectCFC = selectCFC
    },
    async handleConsult() {
      this.autoescola = this.autoescola ? this.autoescola : ''

      await this.loadData()
    },
    async loadData() {
      if(!this.inputs.initialPeriod || !this.inputs.finalPeriod)
      {
        this.$toasted.show('Obrigatório informar período inicial e final.', {
          position: 'top-right',
        })
        return
      }
      this.table.load = true
      this.pagination = ''
      this.autoescolasComUsuarios = []

      const filters = `usuario=${this.inputs.usuario}&periodo_inicio=${this.inputs.initialPeriod}&periodo_fim=${this.inputs.finalPeriod}&formato=json`
      this.filters = filters

      const consult = `${urlApi}/relatorio/consulta-api-candidato/exportar?schema=${this.autoescola}&${filters}`
      this.consult = consult

      try {
        const response = await this.$http.get(consult)
        
        // Se vier agrupamento por autoescola, salvar para exibir
        if (response.body && response.body.autoescolas_com_usuarios) {
          this.autoescolasComUsuarios = response.body.autoescolas_com_usuarios
        }
        
        // Só chama callbackDataPaginate se tiver dados paginados
        if (response.body && response.body.dados) {
          this.callbackDataPaginate(response)
        }
      } catch (err) {
        let mensagem = err && err.body && err.body.mensagem ? err.body.mensagem : 'Erro ao buscar logs.'
        this.$toasted.show(mensagem, {
          position: 'top-right',
        })
        this.autoescolasComUsuarios = []
        this.table.data = []
        this.pagination = null
      } finally {
        this.table.load = false
      }
    },
    callbackDataPaginate(response) {
      if (!response.body || !response.body.dados) {
        this.$toasted.show('Nenhum log encontrado.', {
          position: 'top-right',
        })
        return
      }

      let responseData = response.body.dados

      if (!responseData || !responseData.data || !responseData.data.length) {
        this.$toasted.show('Nenhum log encontrado.', {
          position: 'top-right',
        })
        this.table.data = []
        this.pagination = null
        return
      }

      this.table.currentPage = responseData.current_page
      this.table.data = responseData.data
      this.table.firstPageUrl = responseData.first_page_url
      this.table.from = responseData.from
      this.table.lastPage = responseData.last_page
      this.table.lastPageUrl = responseData.last_page_url
      this.table.nextPageUrl = responseData.next_page_url
      this.table.path = responseData.path
      this.table.perPage = responseData.per_page
      this.table.prevPageUrl = responseData.prev_page_url
      this.table.to = responseData.to
      this.table.total = responseData.total

      this.table.pages = []
      for (let i = 1; i <= (responseData.last_page || 1); i++) {
        this.table.pages.push(i)
      }

      this.items = this.table.data
      this.pagination = responseData
    },
    async navigate(page) {
      this.table.load = true

      await this.$http.get(`${this.consult}&page=${page}`)
        .then(this.callbackDataPaginate)
        .catch(err => {
          this.$toasted.show('Erro ao buscar logs.', {
            position: 'top-right',
          })
        })
    },
    async downloadFilePDF() {
      this.downloadPDFLoading = true

      // Validar se há dados para gerar o relatório
      if (!this.autoescolasComUsuarios || this.autoescolasComUsuarios.length < 1) {
        this.$toasted.show('Realize uma consulta antes de baixar o relatório PDF.', {
          position: 'top-right',
        })

        this.downloadPDFLoading = false
        return
      }

      const filters = `usuario=${this.inputs.usuario}&periodo_inicio=${this.inputs.initialPeriod}&periodo_fim=${this.inputs.finalPeriod}&formato=pdf`
      this.filters = filters

      const consult = `${urlApi}/relatorio/consulta-api-candidato/exportar?schema=${this.autoescola}&${filters}`
      await this.$http.get(consult, { responseType: 'blob' })
        .then(response => {
          // Criar URL do blob para download direto
          const blob = new Blob([response.body], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.download = 'relatorio-consultas-api-candidato.pdf';
          link.href = url;

          document.body.appendChild(link);
          link.click();

          // Limpar recursos
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(err => {
          this.$toasted.show('Erro ao fazer o download do relatório.', {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.downloadPDFLoading = false
        })
    },
    async downloadFileXLSX() {
      // Validar se há dados para gerar o relatório
      if (!this.autoescolasComUsuarios || this.autoescolasComUsuarios.length < 1) {
        this.$toasted.show('Realize uma consulta antes de baixar o relatório XLSX.', {
          position: 'top-right',
        })
        return
      }

      // Inicializar estado do download
      this.downloadXLSXLoading = true
      this.isDownloading = true
      this.downloadProgress = 0

      const filters = `usuario=${this.inputs.usuario}&periodo_inicio=${this.inputs.initialPeriod}&periodo_fim=${this.inputs.finalPeriod}&formato=csv`

      const consult = `${urlApi}/relatorio/consulta-api-candidato/exportar?schema=${this.autoescola}&${filters}`
      
      try {
        console.log('Iniciando download...')
        
        // Iniciar simulação de progresso
        this.simulateProgress()
        
        // Criar uma instância de AbortController para cancelamento
        const controller = new AbortController()
        this.downloadController = controller

        const response = await this.$http.get(consult, {
          responseType: 'blob',
          timeout: 300000, // 5 minutos para datasets grandes
          signal: controller.signal,
          onDownloadProgress: (progressEvent) => {
            console.log('onDownloadProgress ativado:', progressEvent)
            
            // Parar simulação quando receber evento real
            if (this.progressInterval) {
              clearInterval(this.progressInterval)
              this.progressInterval = null
              console.log('Simulação parada, usando progresso real')
            }
            
            if (progressEvent.lengthComputable && progressEvent.total > 0) {
              // Progresso baseado no Content-Length
              const percentCompleted = Math.round((progressEvent.loaded / progressEvent.total) * 100)
              this.downloadProgress = Math.min(percentCompleted, 95)
              console.log(`Progresso real: ${this.downloadProgress}%`)
            } else {
              // Fallback: progresso baseado em bytes recebidos
              const loadedMB = progressEvent.loaded / (1024 * 1024)
              if (loadedMB > 0) {
                const estimatedProgress = Math.min(90, 20 + (loadedMB * 10))
                this.downloadProgress = Math.round(estimatedProgress)
                console.log(`Progresso estimado: ${this.downloadProgress}%`)
              }
            }
          }
        })

        console.log('Resposta recebida, finalizando download...')
        
        // Parar qualquer simulação em andamento
        if (this.progressInterval) {
          clearInterval(this.progressInterval)
          this.progressInterval = null
        }

        // Finalizar progresso
        this.downloadProgress = 100

        // Dar um pequeno delay para mostrar 100%
        await new Promise(resolve => setTimeout(resolve, 300))

        // Criar URL do blob para download direto
        const blob = new Blob([response.body], { 
          type: 'text/csv;charset=utf-8' 
        })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.download = 'relatorio-consultas-api-candidato.csv'
        link.href = url

        document.body.appendChild(link)
        link.click()

        // Limpar recursos
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$toasted.show('Download concluído com sucesso!', {
          position: 'top-right',
          type: 'success'
        })

      } catch (err) {
        // Parar simulação em caso de erro
        if (this.progressInterval) {
          clearInterval(this.progressInterval)
          this.progressInterval = null
        }
        
        if (err.name === 'AbortError') {
          console.log('Download cancelado pelo usuário')
        } else {
          console.error('Erro no download:', err)
          this.$toasted.show('Erro ao fazer o download do relatório.', {
            position: 'top-right',
            type: 'error'
          })
        }
      } finally {
        // Limpar qualquer simulação restante
        if (this.progressInterval) {
          clearInterval(this.progressInterval)
          this.progressInterval = null
        }
        
        // Resetar estado
        this.downloadXLSXLoading = false
        this.isDownloading = false
        this.downloadProgress = 0
        this.downloadController = null
      }
    },

    cancelDownload() {
      // Cancelar requisição se existir
      if (this.downloadController) {
        this.downloadController.abort()
      }
      
      // Cancelar simulação de progresso se existir
      if (this.progressInterval) {
        clearInterval(this.progressInterval)
        this.progressInterval = null
      }
      
      // Resetar estado
      this.downloadXLSXLoading = false
      this.isDownloading = false
      this.downloadProgress = 0
      this.downloadController = null
      
      this.$toasted.show('Download cancelado.', {
        position: 'top-right',
        type: 'info'
      })
    },

    // Método para simular progresso quando onDownloadProgress não funciona
    simulateProgress() {
      this.downloadProgress = 5
      this.progressInterval = setInterval(() => {
        if (this.downloadProgress < 90) {
          this.downloadProgress += Math.random() * 10 + 2
          if (this.downloadProgress > 90) {
            this.downloadProgress = 90
          }
        }
      }, 500)
    },
    clearInputs() {
      const select = this.$refs.autoescola
      if (select && select.selectItem) {
        select.selectItem({
          value: '',
          text: ''
        })
      }

      this.autoescola = ''

      this.inputs = {
        usuario: '',
        initialPeriod: '',
        finalPeriod: '',
        email: '',
      }

      this.filters = ''
      this.autoescolasComUsuarios = []
      this.expandedCards = []
      this.table.data = []
      this.pagination = ''
      // Limpar cache
      this.lastProcessedData = null
    },
    openModal() {
      this.$refs.fileModal.open()
    },
    
    // Método estático para formatação (não reativo)
    formatAutoescolaNameStatic(schema) {
      if (!schema || typeof schema !== 'string') return ''
      
      return schema
        .replace(/autoescola/gi, '')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .split(/[\s_-]+/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
        .trim() || schema
    },
    
    // Métodos utilitários estáticos
    getProgressWidthStatic(value, total) {
      if (!total || total <= 0 || !value) return 0
      return Math.min(100, Math.max(0, (value / total) * 100))
    },
    
    getRankClassStatic(index) {
      const classes = ['rank-gold', 'rank-silver', 'rank-bronze']
      return classes[index] || ''
    },
    
    toggleExpandCard(index) {
      if (this.expandedCards.includes(index)) {
        this.expandedCards = this.expandedCards.filter(i => i !== index)
      } else {
        this.expandedCards = [...this.expandedCards, index]
      }
    },
    
    // Métodos mantidos para compatibilidade (caso sejam chamados em outros lugares)
    formatAutoescolaName(schema) {
      return this.formatAutoescolaNameStatic(schema)
    },
    getTopUsers(usuarios) {
      if (!usuarios || !Array.isArray(usuarios)) return []
      return usuarios
        .slice()
        .sort((a, b) => (b.total || 0) - (a.total || 0))
        .slice(0, 3)
    },
    getRankClass(index) {
      return this.getRankClassStatic(index)
    },
    getProgressWidth(value, total) {
      return this.getProgressWidthStatic(value, total)
    },
    isCardExpanded(index) {
      return this.expandedCards.includes(index)
    },
  },
}

</script>

<style scoped>
/* Seção Header */
.section-header {
  text-align: center;
  margin-bottom: 2rem;
}

.section-title {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.section-subtitle {
  font-size: 1rem;
  color: #6c757d;
}

/* Cards de Métricas */
.metric-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  transition: transform 0.2s ease;
}

.metric-card:hover {
  transform: translateY(-2px);
}

.metric-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  margin-right: 1rem;
}

.metric-content h4 {
  font-size: 2rem;
  font-weight: bold;
  margin: 0;
  color: #2c3e50;
}

.metric-content p {
  margin: 0;
  color: #6c757d;
  font-size: 0.9rem;
}

/* Grid das Autoescolas */
.autoescolas-grid {
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
}

/* Cards das Autoescolas */
.autoescola-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
}

.autoescola-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0,0,0,0.12);
}

/* Header do Card */
.card-header-modern {
  background: #1C2D5A;
  color: white;
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.autoescola-info {
  display: flex;
  align-items: center;
}

.autoescola-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255,255,255,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
  margin-right: 1rem;
}

.autoescola-details h5 {
  margin: 0;
  font-weight: 600;
  font-size: 1.1rem;
}

.autoescola-schema {
  margin: 0;
  opacity: 0.8;
  font-size: 0.8rem;
}

.total-badge {
  text-align: center;
}

.total-number {
  display: block;
  font-size: 1.8rem;
  font-weight: bold;
}

.total-label {
  font-size: 0.8rem;
  opacity: 0.9;
}

/* Conteúdo do Card */
.card-content {
  padding: 1.5rem;
}

.content-title {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

/* Ranking de Usuários */
.users-ranking {
  margin-bottom: 1rem;
}

.user-rank-item {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 10px;
  margin-bottom: 0.5rem;
  transition: all 0.2s ease;
}

.user-rank-item:hover {
  background: #e9ecef;
}

.rank-position {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 1rem;
  color: white;
  font-size: 0.8rem;
}

.rank-gold .rank-position {
  background: #ffd700;
}

.rank-silver .rank-position {
  background: #c0c0c0;
}

.rank-bronze .rank-position {
  background: #cd7f32;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name {
  display: block;
  font-weight: 500;
  color: #2c3e50;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-count {
  display: block;
  color: #6c757d;
  font-size: 0.75rem;
}

/* Barra de Progresso */
.progress-bar {
  width: 80px;
  height: 6px;
  background: #e9ecef;
  border-radius: 3px;
  overflow: hidden;
  margin-left: 1rem;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea, #764ba2);
  transition: width 0.3s ease;
}

/* Botão Toggle */
.toggle-btn {
  border-radius: 20px;
  font-size: 0.8rem;
  padding: 0.5rem 1rem;
}

/* Tabela Moderna */
.table-modern {
  margin: 0;
  border-radius: 8px;
  overflow: hidden;
}

.table-modern thead th {
  background: #f8f9fa;
  border: none;
  font-weight: 600;
  color: #2c3e50;
  font-size: 0.8rem;
}

.table-modern tbody tr:hover {
  background: #f8f9fa;
}

.table-rank {
  background: #e9ecef;
  color: #6c757d;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
}

.table-user {
  display: flex;
  align-items: center;
}

.user-avatar-small {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #667eea;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: bold;
  margin-right: 0.5rem;
}

.user-name-table {
  font-size: 0.8rem;
  color: #2c3e50;
}

.count-badge {
  background: #e3f2fd;
  color: #1976d2;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

/* Percentual */
.percentage-container {
  display: flex;
  align-items: center;
}

.percentage-text {
  font-size: 0.75rem;
  font-weight: 600;
  color: #2c3e50;
  margin-right: 0.5rem;
  min-width: 35px;
}

.mini-progress {
  flex: 1;
  height: 4px;
  background: #e9ecef;
  border-radius: 2px;
  overflow: hidden;
}

.mini-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea, #764ba2);
  transition: width 0.3s ease;
}

/* Responsividade */
@media (max-width: 768px) {
  .autoescolas-grid {
    grid-template-columns: 1fr;
  }
  
  .metric-card {
    margin-bottom: 1rem;
  }
  
  .card-header-modern {
    flex-direction: column;
    text-align: center;
  }
  
  .autoescola-info {
    margin-bottom: 1rem;
  }
  
  .user-rank-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .progress-bar {
    width: 100%;
    margin-left: 0;
    margin-top: 0.5rem;
  }
}

/* Barra de Progresso Custom para Download */
.progress-container {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.progress-label {
  font-size: 0.9rem;
  color: #2c3e50;
  font-weight: 500;
}

.progress-percentage {
  font-size: 0.8rem;
  color: #1C2D5A;
  font-weight: 600;
}

.progress-bar-custom {
  width: 100%;
  height: 8px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.progress-fill-custom {
  height: 100%;
  background: linear-gradient(90deg, #1C2D5A 0%, #4CAF50 100%);
  border-radius: 4px;
  transition: width 0.3s ease;
  position: relative;
}

.progress-fill-custom::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
  background-size: 20px 20px;
  animation: move 1s linear infinite;
}

@keyframes move {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 20px 20px;
  }
}
</style>